module.exports = "/_next/static/images/6a21c6379c2e3718be6fbfbfd9c1619c-2-cards@0.75x.jpg.webp";